<template>
  <el-container class="creator-center">
    <el-header class="header">
      <CreatorHeader />
    </el-header>
    <el-container>
      <div class="main-container">
        <CreatorSidebar />
        <div class="right-wrap">
          <div class="main-content">
            <div class="tab-nav">
              <div class="leftitem">
                <el-tabs v-model="activeTab">
                  <el-tab-pane
                    label="用户头像"
                    name="all"
                    style="font-size: 18px">
                  </el-tab-pane>
                </el-tabs>
              </div>
            </div>
            <div class="user-profile-container">
              <el-row :gutter="20">
                <el-col :span="15">
                  <p>请选择头像</p>
                  <div class="RC-con-a">
                    <div
                      class="RC-con-a-list"
                      @click="ClickAvatar(item.id, item.url, item.avatar)"
                      v-for="item in avatarlistData"
                      :key="item.id">
                      <div class="RC-con-a-list-item">
                        <span class="RC-con-a-list-item-avatar">
                          <img
                            :src="item.url"
                            width="64"
                            height="64" />
                          <i
                            class="M-icon"
                            :class="
                              userAvatar.selectedAvatar == item.id
                                ? 'M-icon-check'
                                : ''
                            "></i>
                        </span>
                      </div>
                    </div>
                  </div>
                </el-col>
                <el-col :span="9">
                  <div class="profile-content">
                    <!-- 头像上传区域 -->
                    <div class="avatar-upload">
                      <div class="upload-tips">
                        <el-avatar
                          :src="userAvatar.userAvatarUrl"
                          :size="100" />
                      </div>
                    </div>
                  </div>
                </el-col>
              </el-row>
              <el-row
                :gutter="120"
                style="margin-top: 120px">
                <el-col>
                  <el-button
                    type="danger"
                    @click="updateAvatarBtn"
                    size="large"
                    :disabled="userAvatar.btnshow"
                    >保存修改</el-button
                  >
                </el-col>
              </el-row>
            </div>
          </div>
        </div>
      </div>
    </el-container>
  </el-container>
</template>

<script setup lang="ts">
import { ref, onMounted, reactive } from "vue";
import { ElMessage } from "element-plus";

import CreatorSidebar from "@/components/CreatorSidebar.vue";
import CreatorHeader from "@/components/CreatorHeader.vue";
import { useHead } from "@vueuse/head";
import { WebSite_Name } from "@/interface/globalindex";
import axiosInstance from "@/utils/axiosInstance";

const activeTab = ref<string>("all");

interface UserAvatarInfo {
  id: number;
  url: string;
  avatar: string;
}
const avatarlistData = ref<UserAvatarInfo[]>([]);

const userAvatar = reactive({
  selectedAvatar: 0,
  userAvatarUrl: "",
  avatarName: "",
  btnshow: true,
});

const ClickAvatar = (id: number, url: string, name: string) => {
  userAvatar.selectedAvatar = id;
  userAvatar.userAvatarUrl = url;
  userAvatar.avatarName = name;
  userAvatar.btnshow = false;
};

const SSRData = ref({
  title: "个人头像 - " + WebSite_Name,
  description:
    "默认代码,defaultcode.cn 是宁波的开发者技术社区，为开发者提供纯粹、高质的技术交流平台，让有意思的人聚在一起。",
  keywords:
    "默认代码,默认代码社区,宁波技术社区,宁波开发者技术交流社区,程序员中文技术社区",
});

// 使用组合式 API 设置 head
useHead({
  title: SSRData.value.title,
  meta: [
    { name: "description", content: SSRData.value.description },
    { name: "keywords", content: SSRData.value.keywords },
  ],
});

onMounted(() => {
  activeTab.value = "all";
  fetchUserDefaultAvatarList();
  fetchUserInfoAvatar();
});

const fetchUserDefaultAvatarList = async () => {
  try {
    const response = await axiosInstance.post(
      "/api/UserInfo/GetUserDefaultAvatarList",
      {}
    );
    var result = response.data;
    if (result.success) {
      avatarlistData.value = result.data;
    }
  } catch (error) {
    console.error("fail:", error);
  }
};
// 更新头像
const updateAvatarBtn = () => {
  if (userAvatar.avatarName === "") {
    ElMessage.error("请选择头像");
    return;
  }
  var postdata = {
    avatar_url: userAvatar.avatarName,
    uuid: "100000001",
  };
  axiosInstance.post("api/UserInfo/UpdateUserAvatar", postdata).then((res) => {
    var result = res.data;
    if (result.success) {
      ElMessage.success("修改成功");
      fetchUserInfoAvatar();
      userAvatar.btnshow = true;
    } else {
      ElMessage.error(result.message);
    }
  });
};

// 获取个人头像
const fetchUserInfoAvatar = async () => {
  try {
    const response = await axiosInstance.post(
      "/api/UserInfo/UserInfoAvatar",
      {}
    );
    var result = response.data;
    if (result.success) {
      userAvatar.selectedAvatar = result.data.avatar_id;
      userAvatar.userAvatarUrl = result.data.avatar_url;
      userAvatar.avatarName = result.data.avatar_name;
    }
  } catch (error) {
    console.error("fail:", error);
  }
};
</script>

<style scoped>
.creator-center {
  width: 100%;
  height: 100%;
}
.header {
  justify-content: space-between;
  padding: 0 20px;
  background: #fff;
  transform: translateZ(0);
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  transition: transform 0.2s;
  z-index: 250;
}
.main-container {
  position: relative;
  margin: 0 auto;
  width: 100%;
  max-width: 1200px;
  margin-top: 22px;
}

.right-wrap {
  width: 980px;
  margin-left: 220px;
}

.main-content {
  min-height: calc(100vh - 108px);
  margin-bottom: 24px;
  padding: 0 20px;
  background: #fff;
  margin-top: 59px;
}

.tab-nav {
  position: relative;
  margin-bottom: 15px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
  border-bottom: 1px solid #dcdfe6;
}
.leftitem {
  position: relative;
  z-index: 1;
  float: left;
  white-space: nowrap;
  width: 200px;
}
.el-tabs {
  --el-tabs-header-height: 56px !important;
  line-height: 56px !important;
  vertical-align: top !important;
  margin-bottom: 0px 0px 0px 0px !important;
}

.leftitem ::v-deep .el-tabs__header {
  margin-bottom: 0px;
}
.leftitem ::v-deep .el-tabs__item {
  font-size: 16px;
}
.leftitem ::v-deep .el-tabs__item.is-active,
.el-tabs__item:hover {
  color: #cc5656;
}
.leftitem ::v-deep .el-tabs__active-bar {
  background-color: #cc5656;
}
.rightitem {
  display: flex;
  align-items: center;
}

.user-profile-container {
  padding: 20px;
  background: #fff;
}

.nav-menu {
  border-right: none;
}

.profile-content {
  display: flex;
  padding: 20px;
}

.user-info-form {
  flex: 1;
  padding-right: 40px;
}

.avatar-upload {
  width: 240px;
  text-align: center;
}

.avatar-uploader {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  padding: 20px;
  cursor: pointer;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 120px;
  height: 120px;
  line-height: 120px;
}

.avatar {
  width: 120px;
  height: 120px;
  border-radius: 50%;
}

.upload-tips {
  color: #999;
  font-size: 12px;
  margin-top: 10px;
}

/* 用户头像 */
.RC-con-a .RC-con-a-list {
  /* display: flex; */
  /* justify-content: center; */
  /* padding-bottom: 20px; */
  width: 565px;
}
.RC-con-a .RC-con-a-list-item {
  display: block;
  float: left;
  flex-direction: column;
  align-items: center;
  min-width: 94px;
  cursor: pointer;
}
.RC-con-a .RC-con-a-list-item:nth-child(4) > span {
  background-position: 0 -139px;
}

.RC-con-a .RC-con-a-list-item .RC-con-a-list-item-avatar {
  display: inline-block;
  width: 64px;
  height: 64px;
  margin-bottom: 10px;
  border-radius: 50%;
  position: relative;
}

.RC-con-a .RC-con-a-list-item .RC-con-a-list-item-icon {
  display: inline-block;
  width: 64px;
  height: 64px;
  background: url("") center top no-repeat;
  background-size: 64px 203px;
  margin-bottom: 10px;
  border-radius: 50%;
  position: relative;
  background-position: 0 -69px;
}

.RC-con-a .RC-con-a-list-item .RC-con-a-list-item-icon .M-icon {
  position: absolute;
  right: -1px;
  bottom: -1px;
  font-size: 1.6em;
}
.M-icon-check::before {
  background-position: -0.8333333333333334em -3.3333333333333335em;
  width: 0.8333333333333334em;
  height: 0.8333333333333334em;
}
.M-icon::before {
  display: inline-block;
  background-image: url(@/assets/user/check_full.png);
}
.RC-con-a .RC-con-a-list-item .RC-con-a-list-item-icon .M-icon {
  font-size: 1.6em;
}
.RC-con-a .RC-con-a-list-item .RC-con-a-list-item-avatar .M-icon {
  font-size: 1.875em;
}
.RC-con-a .RC-con-a-list-item .item-text {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 18px;
  line-height: 18px;
}

.RC-con-a .RC-con-a-list-item .RC-con-a-list-item-avatar {
  position: relative;
}

.RC-con-a .RC-con-a-list-item .RC-con-a-list-item-avatar .M-icon-check {
  width: 0.8333333333333334em;
  height: 0.8333333333333334em;
  position: absolute;
  top: 42px;
  right: -16%;
  transform: translateX(-50%);
  color: #67c23a;
  background: white;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  z-index: 2;
  background-image: url(@/assets/user/check_full.png);
}

.RC-con-a .RC-con-a-list-item .RC-con-a-list-item-avatar img {
  position: relative;
  z-index: 1;
}
.el-button--danger {
  background-color: #cc5656;
  border-color: #cc5656;
  color: #fff;
  cursor: pointer;
  padding: 2px 16px;
  font-size: 14px;
  line-height: 22px;
  border-radius: 2px;
}
</style>
